<template>
    <div class="calendar">
        <Calendar
            v-on:choseDay="clickDay"
            v-on:changeMonth="changeDate"
            :markDate='markDate'
            :markDateMore="markDateMore"
            ref="Calendar"
            :textTop="textTop"
            :sundayStart="true"
        ></Calendar>
        <div class="hover" ref="hover" :style="{left,top: bottom}" v-show="visiter" v-loading="loading">
            <p>待开标：<span class="bid">{{hoverObj.bidopenCount}}宗</span></p>
            <p>待评标：<span class="eval">{{hoverObj.evalCount}}宗</span></p>
        </div>
    </div>
</template>

<script>
import Calendar from 'vue-calendar-component'
import {
    apiFieldApplyBaseFieldapplybaseQueryCalendar,
    apiFieldApplyBaseFieldapplybaseQueryBidTodayCount
} from '@/server/new.js';
import dayjs from '@/utils/dayjs.js';
import $ from 'jquery';
export default {
    components: {
        Calendar
    },
    data () {
        return {
            textTop: ["日", "一", "二", "三", "四", "五", "六"],
            markDate: [
                // '2023/3/10',
                // '2023/4/12',
                // '2023/4/18',
            ],
            markDateMore: [],
            times: [
                dayjs(new Date()).startOf('month').format('YYYY-MM-DD'),
                dayjs(new Date()).endOf('month').format('YYYY-MM-DD'),
            ],
            visiter: false,
            left: 0,
            bottom: 0,
            hoverObj: {},
            loading: false
        }
    },
    mounted() {
        this.apiFieldApplyBaseFieldapplybaseQueryCalendar();
    },
    methods: {
        apiFieldApplyBaseFieldapplybaseQueryCalendar() { //日期范围内哪天有开评标的
            let totay = dayjs(dayjs(new Date()).format('YYYY-MM-DD')).unix(); //今天时间戳
            apiFieldApplyBaseFieldapplybaseQueryCalendar({
                startTime: this.times[0],
                endTime: this.times[1],
                tradeId: null
            }).then(({data}) => {
                let res = data.data;
                res.forEach(item => {
                    if(dayjs(item).unix()>=totay) {
                        this.markDateMore.push({
                            date: item,
                            className: `mark-circle ${dayjs(item).format('YYYY-MM-DD')}`
                        })
                    }else {
                        this.markDateMore.push({
                            date: item,
                            className: `mark-circle--grey ${dayjs(item).format('YYYY-MM-DD')}`
                        })
                    }
                })
                this.$nextTick(() => {
                    // this.$refs.Calendar.$el.children.forEach(item => {
                        const childrenArray = Array.from(this.$refs.Calendar?.$el?.children || []);
                        childrenArray.forEach(item => {
                            const grandchildrenArray = Array.from(item.children || []);
                            grandchildrenArray.forEach(items => {
                            if(items.className === 'wh_content') {
                                const innerChildrenArray = Array.from(items.children || []);
                                if(innerChildrenArray.length > 7) {
                                    innerChildrenArray.forEach(dom => {
                                        // dom.addEventListener('mouseover',(e) => {
                                        //     let day = ''
                                        //     $(dom).find('div').attr('class').split(' ').forEach(index => {
                                        //         if(isNaN(index)&&!isNaN(Date.parse(index))) {
                                        //             day = index;
                                        //         }
                                        //     })
                                        //     this.bottom = $(dom).offset().top - 60 + 'px';
                                        //     this.left = $(dom).offset().left - 17 + 'px';
                                        //     this.apiFieldApplyBaseFieldapplybaseQueryBidTodayCount(day);
                                        // })
                                        // dom.addEventListener('mouseout',(e) => {
                                        //     this.visiter = false;
                                        // })
                                        $(dom).find('div').bind('mouseover',() => {
                                            let day = '';
                                            $(dom).find('div').attr('class').split(' ').forEach(index => {
                                                if(isNaN(index)&&!isNaN(Date.parse(index))) {
                                                    day = index;
                                                }
                                            })
                                            this.bottom = $(dom).offset().top - 60 + 'px';
                                            this.left = $(dom).offset().left - 17 + 'px';
                                            this.apiFieldApplyBaseFieldapplybaseQueryBidTodayCount(day);
                                        })
                                        $(dom).find('div').bind('mouseout',() => {
                                            this.visiter = false;
                                        })
                                    })
                                }
                            }
                        })
                    })
                })
            })
        },
        apiFieldApplyBaseFieldapplybaseQueryBidTodayCount(day) {
            this.visiter = true;
            this.loading = true;
            apiFieldApplyBaseFieldapplybaseQueryBidTodayCount(day).then(({data}) => {
                this.hoverObj = data.data;
            }).finally(() => {
                this.loading = false;
            })
        },
        clickDay(data) {
            // console.log(data); //选中某天
            this.$emit('on-caledar',dayjs(data).format('YYYY-MM-DD'))
        },
        changeDate(data) {
            console.log(data); //左右点击切换月份
            this.times = [
                dayjs(data).startOf('month').format('YYYY-MM-DD'),
                dayjs(data).endOf('month').format('YYYY-MM-DD'),
            ]
            this.apiFieldApplyBaseFieldapplybaseQueryCalendar();
        },
        clickToday(data) {
            console.log(data); //跳到了本月
        }
    }
}
</script>

<style lang="less" scoped>

.calendar {
    border-right: 1px solid #E8E8E8;
    border-radius: 4px;
    // position: relative;
    .hover {
        position: fixed;
        // width: 100px;
        height: 48px;
        background-color: #303133;
        left: 0;
        top: 0;
        border-radius: 4px;
        color: #ffffff;
        font-size: 12px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 6px 8px;
        .bid {
            color: @--color-primary;
        }
        .eval {
            color: #FF9900;
        }
        &:after {
            content: '';
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 8px 8px 0 8px;
            border-color: #303133 transparent transparent transparent;
            position: absolute;
            bottom: -5px;
            left: 50%;
            transform: translateX(-50%);
        }
        p {
            margin-bottom: 0;
            line-height: 1.5;
        }
    }
}

/deep/ .wh_container {
    margin: 0 !important;
    max-width: none !important;
}

/deep/ .wh_content {
    display: flex;
    justify-content: space-around;
}

/deep/ .wh_content_item {
    // height: 36px !important;
    height: 30px !important;
    color: #262626 !important;
    font-size: 14px !important;
    margin-bottom: 6px;
}
/deep/ .wh_top_tag {
    height: 30px !important;
}
/deep/ .wh_item_date {
    // width: 30px !important;
    // height: 30px !important;
    // line-height: 30px !important;
    width: 26px !important;
    height: 26px !important;
    line-height: 26px !important;
    border-radius: 50%;
}

/deep/ .wh_item_date:hover {
    // background: none !important;
    // color: @--color-primary !important;
    background: @--color-primary !important;
    color: #ffffff !important;
}

/deep/ .wh_content_item>.wh_isMark {
    // border: 1px solid @--color-primary !important;
    // border-radius: 50% !important;
    // color: @--color-primary !important;
    // background: none !important;
    // line-height: 28px !important;
    background: @--color-primary !important;
    color: #ffffff !important;
}

/deep/ .wh_content_all {
    background-color: #fff !important;
}


/deep/ .wh_content_item .wh_other_dayhide {
    color: #BFBFBF !important;
}

/deep/ .wh_top_changge li {
    font-size: 16px !important;
    font-weight: 600 !important;
    color: #262626 !important;
}

/deep/ .wh_jiantou1 {
    border-top: 2px solid #8C8C8C !important;
    border-left: 2px solid #8C8C8C !important;
}

/deep/ .wh_jiantou2 {
    border-top: 2px solid #8C8C8C !important;
    border-right: 2px solid #8C8C8C !important;
}

/deep/ .wh_content_item .wh_isToday {
    // background: @--color-primary !important;
    // color: #ffffff !important;
    color: @--color-primary !important;
    border: 1px solid @--color-primary !important;
    background-color: #ffffff !important;
}
/deep/ .wh_content_item .wh_chose_day {
    background:@--color-primary !important;
    color: #ffffff !important;
}
/deep/ .mark-circle {
    position: relative;
    &:after {
        content: '';
        width: 4px;
        height: 4px;
        background-color: #FF9900;
        border-radius: 50%;
        position: absolute;
        bottom: -6px;
        left: 50%;
        transform: translateX(-50%);
    }
}
/deep/ .mark-circle--grey {
    position: relative;
    &:after {
        content: '';
        width: 4px;
        height: 4px;
        background-color: #BCBCBC;
        border-radius: 50%;
        position: absolute;
        bottom: -6px;
        left: 50%;
        transform: translateX(-50%);
    }
}
</style>
